/**
 * ma.js - Modern Ambition Autocomplete Panel Template
 *
 * - Defines the panel layout rendered by autocomplete-js's custom render() hook
 * - querySuggestions is injected by autocomplete-js from the source system
 * - The initial content carousel is populated separately by mountAutocompleteCarousel()
 *   after config.onOpen() resolves.
 * - Checks for the brand determined query length minimum before rendering search results
 */
import { algoliaConfig } from '../../_config';
import { getBrand } from '../../_getBrand';

export function autocompletePanel_MA({ elements, state, render, html }, root) {
  const brand = getBrand();
  const config = algoliaConfig[brand];
  const isSearching = state.query.length >= config.autocomplete.minQueryLength;
  const nbHits = state.context.productsNbHits;
  let seeAllLink = html`
    <a 
      href="/search?q=${encodeURIComponent(state.query)}" 
      class="button ac-see-all ac-see-all--products"
    >
      See all ${nbHits} products
    </a>
  `;

  // Only show 'all results' link if there are more results than the panel cap.
  if (!state.query || !nbHits || nbHits <= config.autocomplete.productHitsPerPage) {
    seeAllLink = "";
  }

  render(html`
    <div class="ac-panel">
      <div class="ac-results__suggestions">
        ${elements.querySuggestions}
      </div>

      ${isSearching ? html`
        <div class="ac-results__collections-pages-and-pages">
          ${elements.collectionsAndPages}
        </div>

        <div class="ac-results__products">
          <div class="aa-SourceHeader">Products</div>
          <div id="autocompleteCarouselProducts" class="splide" aria-label="Search Results Carousel">
            <div class="splide__track">
              <ul class="splide__list"></ul>
            </div>
          </div>
          <div class="aa-SourceFooter">  
            ${seeAllLink}
          </div>
        </div>
        
      ` : html`
        <div class="ac-results__collections-pages">
            <div class="aa-SourceHeader">Placeholder</div>
            <ul class="ac-results__static-content-list">
                <li>
                  <a class="link" href="#">Store Locator</a>
                </li>
                <li>
                  <a class="link" href="https://modernambition.com/pages/fit-and-tailoring">Fit and Tailoring Guide</a>
                </li>
                <li>
                  <a class="link" href="https://modernambition.com/pages/in-store-experience">Book an Appointment</a>
                </li>
            </ul>
        </div>
        
        <div class="ac-results__initial-content">
          <div class="aa-SourceHeader">Tailored Recommendations</div>
          <div id="autocompleteCarouselInitial" class="splide" aria-label="Recommendations Carousel">
            <div class="splide__track">
              <ul class="splide__list"></ul>
            </div>
          </div>
        </div>
      `}
    </div>
  `, root);

  // After render, ensure autocomplete-created source nodes are placed
  // into the correct brand columns. Autocomplete may create these nodes
  // on initial idle render (bestsellers) and leave them attached there;
  // move them into the searching grid when needed.
  setTimeout(() => {
    const collectionsPagesNode = document.querySelector('[data-autocomplete-source-id="collectionsAndPages"]');
    const productsNode = document.querySelector('[data-autocomplete-source-id="products"]');
    const collectionsTarget = root.querySelector('.ac-results__collections-pages');
    const productsTarget = root.querySelector('.ac-results__products');

    if (collectionsPagesNode && collectionsTarget) collectionsTarget.appendChild(collectionsPagesNode);
    if (productsNode && productsTarget) productsTarget.appendChild(productsNode);
  }, 0);
}